<template>
  <div id="app">
    <LmsSurfanaComponent />
  </div>
</template>

<script>
import LmsSurfanaComponent from "@/pages/LmsSurfana/LmsSurfanaComponent";

export default {
  name: 'App',
  components: {
    LmsSurfanaComponent,
  }
}
</script>
